/**
 * Gets and Array from local storage
 * @ignore
 * @param {string} key - Local storage key
 *
 * @return {array}
 */
export default function getArrayFromStorage(key) {
    try {
        // Fetch data and check if it's an array
        const raw = localStorage.getItem(key);
        const data = JSON.parse(raw || '');
        if (!Array.isArray(data))
            throw new Error('Stored data is invalid');
        return data;
    }
    catch (err) {
        // Data is invalid; clear it and return empty array
        localStorage.removeItem(key);
        return [];
    }
}
